var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbMyWishlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16,
    viewBox: "0 0 16.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "db_my_wishlist",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8436",
    "data-name": "Path 8436",
    d: "M15.532,8.367a.349.349,0,0,1-.208-.069C15.146,8.166,11,5.042,11,2.531A2.532,2.532,0,0,1,15.532.979a2.532,2.532,0,0,1,4.532,1.552c0,2.511-4.146,5.635-4.324,5.767a.349.349,0,0,1-.208.069Zm-2-7.67A1.837,1.837,0,0,0,11.7,2.531c0,1.692,2.6,4.077,3.835,5.048,1.238-.971,3.835-3.355,3.835-5.048A1.834,1.834,0,0,0,15.852,1.8a.349.349,0,0,1-.64,0A1.828,1.828,0,0,0,13.532.7Z",
    transform: "translate(-4.064)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    d: "M14.2,13H5.645a.326.326,0,0,1-.322-.256L4.007,6.381a.311.311,0,0,1,.068-.264A.333.333,0,0,1,4.329,6H7.618a.319.319,0,1,1,0,.637H4.73l1.184,5.73h8.012l.539-2.609a.331.331,0,0,1,.387-.25.319.319,0,0,1,.259.374l-.592,2.865A.328.328,0,0,1,14.2,13Z",
    transform: "translate(-1.278 -1.848)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8438",
    "data-name": "Path 8438",
    d: "M4.531,12.458a.348.348,0,0,1-.341-.28L2.462,3.536A1.049,1.049,0,0,0,1.436,2.7H.349a.35.35,0,1,1,0-.7H1.436a1.748,1.748,0,0,1,1.71,1.4l1.728,8.641a.348.348,0,0,1-.274.41.32.32,0,0,1-.068.007Z",
    transform: "translate(0 -0.605)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8439",
    "data-name": "Path 8439",
    d: "M15.185,18.092H3.988a1.048,1.048,0,0,1,0-2.092H5.3a.35.35,0,1,1,0,.7H3.988a.35.35,0,0,0,0,.7h11.2a.35.35,0,0,1,0,.7Z",
    transform: "translate(-0.908 -5.403)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8440",
    "data-name": "Path 8440",
    d: "M7.394,22.789A1.394,1.394,0,1,1,8.788,21.4a1.394,1.394,0,0,1-1.394,1.394Zm0-2.092a.7.7,0,1,0,.7.7.7.7,0,0,0-.7-.7Z",
    transform: "translate(-2.037 -6.789)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    "data-name": "Path 8441",
    d: "M16.394,22.789A1.394,1.394,0,1,1,17.788,21.4a1.394,1.394,0,0,1-1.394,1.394Zm0-2.092a.7.7,0,1,0,.7.7.7.7,0,0,0-.7-.7Z",
    transform: "translate(-5.092 -6.789)",
    fill: "#676767"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbMyWishlist);
export default __webpack_public_path__ + "static/media/db_my_wishlist.ac5767941c845f28bc5e3e408692ee18.svg";
export { ForwardRef as ReactComponent };